import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";

export const retainNonNilValues = (obj: Record<string, any>) =>
  omitBy(obj, isNil);
